<app-ot-breadcrumbs state="locations"></app-ot-breadcrumbs>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col">{{ 'city_name' | l10n }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let city of cityList; index as i">
            <td>
              <a [routerLink]="['/city/' + city.id + '/ot/event/list']">{{ city.name }}</a>
              <span class="secondaryInfo"> - {{ city.venueNames }}</span>
              <div class="secondaryInfo">{{ 'city_happeningCount' | l10n }}: {{ city.otEventCount }}</div>
            </td>
            <td class="list-buttonCell"><button class="btn btn-secondary btn-sm" [routerLink]="['/city/' + city.id + '/ot/event/list']"><span class="fa fa-arrow-circle-right"></span>&nbsp;{{ 'button_select' | l10n }}</button></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
